/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, Platformer_1) {
	    "use strict";
	    var canvas = document.getElementById('js-stage');
	    // Init game
	    new Platformer_1.Platformer({
	        elem: canvas,
	        ctx: canvas.getContext('2d'),
	        width: 512,
	        height: 288
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2), __webpack_require__(3), __webpack_require__(6), __webpack_require__(13), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, checkForCollision_1, getObstacleArr_1, getAntagonistArr_1, Stage_1, Character_1) {
	    "use strict";
	    var Platformer = (function () {
	        function Platformer(canvas) {
	            this.canvas = canvas;
	            canvas.elem.width = canvas.width;
	            canvas.elem.height = canvas.height;
	            this.stage = new Stage_1.Stage(canvas.ctx);
	            this.stage.outerWidth = canvas.width;
	            this.stage.outerHeight = canvas.height;
	            this.stage.innerWidth = canvas.width * 4;
	            this.stage.innerHeight = canvas.height;
	            this.stage.xTranslateStart = canvas.width / 2;
	            this.stage.xTranslateEnd = this.stage.innerWidth - (canvas.width / 2);
	            this.protagonist = new Character_1.Character(canvas.ctx);
	            this.protagonist.x = 16;
	            this.protagonist.y = (this.stage.innerHeight / 2) - this.protagonist.height;
	            this.isJumpKeyPressed = false;
	            this.isShootKeyPressed = false;
	            this._endLoop = false;
	            this._endLoopCount = 0;
	            this.obstacleArr = getObstacleArr_1.getObstacleArr(canvas.ctx, this.stage.innerWidth, this.stage.innerHeight);
	            this.antagonistArr = getAntagonistArr_1.getAntagonistArr(canvas.ctx, this.stage.innerWidth, this.stage.innerHeight);
	            this
	                .bind()
	                .update();
	        }
	        Platformer.prototype.bind = function () {
	            var _this = this;
	            document.addEventListener('keydown', function (e) {
	                _this.onkeydown(e);
	            }, false);
	            document.addEventListener('keyup', function (e) {
	                _this.onkeyup(e);
	            }, false);
	            return this;
	        };
	        Platformer.prototype.onkeydown = function (e) {
	            var protagonist = this.protagonist;
	            var keyCode = e.keyCode;
	            if (keyCode === 39) {
	                protagonist.move('right');
	            }
	            if (keyCode === 37) {
	                protagonist.move('left');
	            }
	            if (keyCode === 38 || keyCode === 32) {
	                // Prevent continuous jumping
	                if (!this.isJumpKeyPressed) {
	                    protagonist.jump();
	                    this.isJumpKeyPressed = true;
	                }
	            }
	            if (keyCode === 90) {
	                // Prevent continuous shooting
	                if (!this.isShootKeyPressed) {
	                    protagonist.shoot();
	                    this.isShootKeyPressed = true;
	                }
	            }
	        };
	        Platformer.prototype.onkeyup = function (e) {
	            var protagonist = this.protagonist;
	            var keyCode = e.keyCode;
	            if (keyCode === 39) {
	                protagonist.stopMove('right');
	            }
	            if (keyCode === 37) {
	                protagonist.stopMove('left');
	            }
	            if (keyCode === 38 || keyCode === 32) {
	                this.isJumpKeyPressed = false;
	            }
	            if (keyCode === 90) {
	                this.isShootKeyPressed = false;
	            }
	        };
	        /** Draws protagonist, antagonists and obstacles */
	        Platformer.prototype.update = function () {
	            var _this = this;
	            var _a = this, canvas = _a.canvas, stage = _a.stage, protagonist = _a.protagonist, antagonistArr = _a.antagonistArr, obstacleArr = _a.obstacleArr;
	            // Clear stage visible area
	            canvas.ctx.clearRect(-stage.x, stage.y, stage.outerWidth, stage.outerHeight);
	            // Update protagonist and its bullets
	            protagonist.update();
	            protagonist.bulletArr.forEach(function (bullet) { bullet.update(); });
	            protagonist.bulletArr.forEach(function (bullet, i) {
	                _this
	                    .cleanBulletArr(protagonist.bulletArr, i, bullet)
	                    .checkForShotCharacter(bullet, antagonistArr)
	                    .checkForBulletCollision(bullet, obstacleArr);
	            });
	            // Update antagonist and its bullets
	            antagonistArr.forEach(function (antagonist) {
	                antagonist.update();
	                antagonist.bulletArr.forEach(function (bullet) { bullet.update(); });
	                antagonist.bulletArr.forEach(function (bullet, i) {
	                    _this
	                        .cleanBulletArr(antagonist.bulletArr, i, bullet)
	                        .checkForShotCharacter(bullet, [protagonist])
	                        .checkForBulletCollision(bullet, obstacleArr);
	                });
	            });
	            // Check if characters has collide with obstacles or if character had
	            // collide with each other
	            obstacleArr.forEach(function (obstacle) {
	                // Invisible obstacles don't affect protagonist
	                if (!obstacle.isInvisible) {
	                    var protagonistCollision = checkForCollision_1.checkForCollision(protagonist, obstacle, true);
	                    if (typeof protagonistCollision === 'object') {
	                        protagonist.collisionHandler(protagonistCollision.side, protagonistCollision.depth);
	                        if (obstacle.canKill) {
	                            protagonist.kill();
	                        }
	                    }
	                }
	                antagonistArr.forEach(function (antagonist) {
	                    var antagonistCollison = checkForCollision_1.checkForCollision(antagonist, obstacle, true);
	                    if (typeof antagonistCollison === 'object') {
	                        antagonist.collisionHandler(antagonistCollison.side, antagonistCollison.depth);
	                    }
	                    if (!antagonist.isDeath) {
	                        var mortalCollision = checkForCollision_1.checkForCollision(protagonist, antagonist);
	                        if (mortalCollision) {
	                            protagonist.kill();
	                            antagonist.kill();
	                        }
	                    }
	                });
	                obstacle.render();
	            });
	            // Render antagonist and its bullets
	            antagonistArr.forEach(function (antagonist) {
	                antagonist.bulletArr.forEach(function (bullet) { bullet.render(); });
	                antagonist.render();
	            });
	            // Render protagonist and its bullets
	            protagonist.bulletArr.forEach(function (bullet) { bullet.render(); });
	            protagonist.render();
	            // Move stage along with protagonist
	            stage.x = protagonist.x;
	            stage.render();
	            // End game validation
	            if (this._endLoop) {
	                if (this._endLoopCount === protagonist.clearWait - 2) {
	                    // Reload website
	                    location.reload();
	                    // Avoid rendering
	                    return this;
	                }
	                this._endLoopCount++;
	            }
	            // Restart game if protagonist is death or very close to the end
	            if (protagonist.isDeath || this.protagonist.x > (stage.innerWidth - protagonist.width - 10)) {
	                this._endLoop = true;
	            }
	            // Keep updating if everything is ok
	            requestAnimationFrame(this.update.bind(this));
	            return this;
	        };
	        /** Cleans bullets that are out of sight */
	        Platformer.prototype.cleanBulletArr = function (bulletArr, index, bullet) {
	            var stage = this.stage;
	            // Check if is out of sight
	            if (bullet.remove || (bullet.x < -stage.x || bullet.x > -stage.x + stage.outerWidth)) {
	                // Remove from array
	                bulletArr.splice(index, 1);
	            }
	            return this;
	        };
	        /** Checks if a bullet has collided with a Character */
	        Platformer.prototype.checkForShotCharacter = function (bullet, characterArr) {
	            var _this = this;
	            characterArr.forEach(function (character) {
	                if (!character.isDeath) {
	                    _this.checkForBulletCollision(bullet, [character], function (character) {
	                        character.kill();
	                    });
	                }
	            });
	            return this;
	        };
	        /** Checks if a bullet has collided with another Rect */
	        Platformer.prototype.checkForBulletCollision = function (bullet, targetArr, handler) {
	            targetArr.forEach(function (target) {
	                var collision = checkForCollision_1.checkForCollision(bullet, target, true);
	                // Invisible obstacles don't affect bullets
	                if (target['isInvisible'])
	                    return;
	                if (typeof collision === 'object') {
	                    bullet.collisionHandler(collision.side, collision.depth);
	                    if (typeof handler === 'function') {
	                        handler(target);
	                    }
	                }
	            });
	            return this;
	        };
	        return Platformer;
	    }());
	    exports.Platformer = Platformer;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    "use strict";
	    /**
	     * Checks for collision between rects
	     * @see { @link http://bit.ly/2iR5hvL }
	     * @see { @link http://bit.ly/2ijiL26 }
	     * @see { @link https://mzl.la/2iyMrWV }
	     */
	    function checkForCollision(rectA, rectB, deep) {
	        if (deep === void 0) { deep = false; }
	        // Distance between centers in x and y axis
	        var xDist = (rectA.x + rectA.width / 2) - (rectB.x + rectB.width / 2);
	        var yDist = (rectA.y + rectA.height / 2) - (rectB.y + rectB.height / 2);
	        // Width and height halfs sum of each rect (is the distance between centers
	        // if the rects were side by side and aligned vertically or horizontally).
	        var xHalfs = (rectA.width + rectB.width) / 2;
	        var yHalfs = (rectA.height + rectB.height) / 2;
	        // If the distance between centers is less than the halfs in each axis then
	        // rects are colliding.
	        if (Math.abs(xDist) < xHalfs && Math.abs(yDist) < yHalfs) {
	            if (deep) {
	                var xDepth = xHalfs - Math.abs(xDist);
	                var yDepth = yHalfs - Math.abs(yDist);
	                if (xDepth >= yDepth) {
	                    return {
	                        side: yDist > 0 ? 'top' : 'bottom',
	                        depth: yDepth
	                    };
	                }
	                else {
	                    return {
	                        side: xDist > 0 ? 'left' : 'right',
	                        depth: xDepth
	                    };
	                }
	            }
	            else {
	                return true;
	            }
	        }
	        return false;
	    }
	    exports.checkForCollision = checkForCollision;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, Obstacle_1) {
	    "use strict";
	    function getBlock(ctx, width, height) {
	        if (width === void 0) { width = 1; }
	        if (height === void 0) { height = 1; }
	        var block = new Obstacle_1.Obstacle(ctx);
	        block.width = 32 * width;
	        block.height = 32 * height;
	        return block;
	    }
	    function getInvisibleBlock(ctx, width, height) {
	        if (width === void 0) { width = 1; }
	        if (height === void 0) { height = 1; }
	        var block = getBlock(ctx, width, height);
	        block.isInvisible = true;
	        return block;
	    }
	    function getLava(ctx, width, height) {
	        if (width === void 0) { width = 1; }
	        if (height === void 0) { height = 1; }
	        var block = new Obstacle_1.Obstacle(ctx);
	        block.canKill = true;
	        block.width = 32 * width;
	        block.height = 16 * height;
	        block.fillStyle = '#ff4a4a';
	        return block;
	    }
	    function getObstacleArr(ctx, width, height) {
	        var obstacleArr = [];
	        // LIMITS
	        ////////////////////////////////////////////////////////////////////////////
	        var rightLimit = new Obstacle_1.Obstacle(ctx);
	        rightLimit.width = 20;
	        rightLimit.height = height;
	        rightLimit.x = width;
	        rightLimit.y = 0;
	        obstacleArr.push(rightLimit);
	        var leftLimit = new Obstacle_1.Obstacle(ctx);
	        leftLimit.width = 20;
	        leftLimit.height = height;
	        leftLimit.x = 0 - 20;
	        leftLimit.y = 0;
	        obstacleArr.push(leftLimit);
	        // PART 1
	        ////////////////////////////////////////////////////////////////////////////
	        var p1Floor = getBlock(ctx, 7);
	        p1Floor.x = 0;
	        p1Floor.y = height - p1Floor.height;
	        obstacleArr.push(p1Floor);
	        var p1FloorRightLimit = getInvisibleBlock(ctx, 1, 1);
	        p1FloorRightLimit.x = p1Floor.x + p1Floor.width;
	        p1FloorRightLimit.y = p1Floor.y - p1FloorRightLimit.height;
	        obstacleArr.push(p1FloorRightLimit);
	        var p1ProtagonistGuard = getInvisibleBlock(ctx, 1, 1);
	        p1ProtagonistGuard.x = p1ProtagonistGuard.width;
	        p1ProtagonistGuard.y = p1FloorRightLimit.y;
	        obstacleArr.push(p1ProtagonistGuard);
	        var p1Lava = getLava(ctx, 11, 1);
	        p1Lava.x = p1Floor.x + p1Floor.width;
	        p1Lava.y = height - p1Lava.height;
	        obstacleArr.push(p1Lava);
	        var p1StepsCount = 0;
	        while (p1StepsCount < 5) {
	            var p1Step = getBlock(ctx);
	            p1Step.y = height;
	            p1Step.y -= p1StepsCount % 2 ? p1Step.height * 2 : p1Step.height * 3;
	            p1Step.x = (p1Floor.x + p1Floor.width) + p1Step.width;
	            p1Step.x += (p1Step.width * 2) * p1StepsCount;
	            obstacleArr.push(p1Step);
	            ++p1StepsCount;
	        }
	        // PART 2
	        ////////////////////////////////////////////////////////////////////////////
	        var p2LeftLimit = getBlock(ctx, 1, 2);
	        p2LeftLimit.x = p1Lava.x + p1Lava.width;
	        p2LeftLimit.y = height - p2LeftLimit.height;
	        obstacleArr.push(p2LeftLimit);
	        var p2Floor = getBlock(ctx, 9);
	        p2Floor.x = p2LeftLimit.x + p2LeftLimit.width;
	        p2Floor.y = height - p2Floor.height;
	        obstacleArr.push(p2Floor);
	        var p2RightLimit = getBlock(ctx, 1, 3);
	        p2RightLimit.x = p2Floor.x + p2Floor.width;
	        p2RightLimit.y = height - p2RightLimit.height;
	        obstacleArr.push(p2RightLimit);
	        var p2FloatBlock = getBlock(ctx, 7);
	        p2FloatBlock.x = p2LeftLimit.x + p2LeftLimit.width;
	        p2FloatBlock.y = height - (p2FloatBlock.height * 5);
	        obstacleArr.push(p2FloatBlock);
	        var p2FloatBlockLeftLimit = getInvisibleBlock(ctx, 1);
	        p2FloatBlockLeftLimit.x = p2FloatBlock.x - p2FloatBlockLeftLimit.height;
	        p2FloatBlockLeftLimit.y = p2FloatBlock.y - p2FloatBlockLeftLimit.width;
	        obstacleArr.push(p2FloatBlockLeftLimit);
	        var p2FloatBlockRightLimit = getInvisibleBlock(ctx, 1);
	        p2FloatBlockRightLimit.x = p2FloatBlock.x + p2FloatBlock.width;
	        p2FloatBlockRightLimit.y = p2FloatBlock.y - p2FloatBlockRightLimit.width;
	        obstacleArr.push(p2FloatBlockRightLimit);
	        // PART 3
	        ////////////////////////////////////////////////////////////////////////////
	        var p3Floor = getLava(ctx, 8);
	        p3Floor.x = p2RightLimit.x + p2RightLimit.width;
	        p3Floor.y = height + (p3Floor.height * 2);
	        obstacleArr.push(p3Floor);
	        var p3StepLeft = getBlock(ctx);
	        p3StepLeft.x = p3Floor.x + (p3StepLeft.width * 2);
	        p3StepLeft.y = height - (p3StepLeft.height * 2);
	        obstacleArr.push(p3StepLeft);
	        var p3StepRight = getBlock(ctx);
	        p3StepRight.x = p3Floor.x + (p3StepLeft.width * 5);
	        p3StepRight.y = p3StepLeft.y;
	        obstacleArr.push(p3StepRight);
	        // PART 4
	        ////////////////////////////////////////////////////////////////////////////
	        var p4LeftLimit = getBlock(ctx, 1, 3);
	        p4LeftLimit.x = p3Floor.x + p3Floor.width;
	        p4LeftLimit.y = height - p4LeftLimit.height;
	        obstacleArr.push(p4LeftLimit);
	        var p4Floor = getBlock(ctx, 10);
	        p4Floor.x = p4LeftLimit.x + p4LeftLimit.width;
	        p4Floor.y = height - p4Floor.height;
	        obstacleArr.push(p4Floor);
	        var p4FloorRightLimit = getInvisibleBlock(ctx, 1, 3);
	        p4FloorRightLimit.x = p4Floor.x + p4Floor.width;
	        p4FloorRightLimit.y = height - (p4FloorRightLimit.height);
	        obstacleArr.push(p4FloorRightLimit);
	        var p4Lava = getLava(ctx, 9);
	        p4Lava.x = p4FloorRightLimit.x;
	        p4Lava.y = height - p4Lava.height;
	        obstacleArr.push(p4Lava);
	        var p4Step = getBlock(ctx);
	        p4Step.x = p4FloorRightLimit.x + (p4Step.width * 4);
	        p4Step.y = height - p4Step.height;
	        obstacleArr.push(p4Step);
	        // PART 5
	        ////////////////////////////////////////////////////////////////////////////
	        var p5StepCount = 0;
	        while (p5StepCount < 7) {
	            var p5StepHeight = p5StepCount < 5 ? p5StepCount + 1 : 5;
	            var p5Step = getBlock(ctx, 1, p5StepHeight);
	            p5Step.x = (p4Lava.x + p4Lava.width) + (p5Step.width * p5StepCount);
	            p5Step.y = height - p5Step.height;
	            obstacleArr.push(p5Step);
	            ++p5StepCount;
	        }
	        return obstacleArr;
	    }
	    exports.getObstacleArr = getObstacleArr;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, Rect_1) {
	    "use strict";
	    var Obstacle = (function (_super) {
	        __extends(Obstacle, _super);
	        function Obstacle(context) {
	            var _this = _super.call(this, context) || this;
	            _this.context = context;
	            _this.canKill = false;
	            _this.isInvisible = false;
	            _this.fillStyle = 'black';
	            _this.fillStyle = 'black';
	            return _this;
	        }
	        Obstacle.prototype.render = function () {
	            var _a = this, context = _a.context, isInvisible = _a.isInvisible;
	            context.fillStyle = isInvisible ? 'transparent' : this.fillStyle;
	            _super.prototype.render.call(this);
	            context.fill();
	            return this;
	        };
	        return Obstacle;
	    }(Rect_1.Rect));
	    exports.Obstacle = Obstacle;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    "use strict";
	    var Rect = (function () {
	        function Rect(context) {
	            this.context = context;
	            this.x = 0;
	            this.y = 0;
	            this.width = 0;
	            this.height = 0;
	        }
	        Rect.prototype.render = function () {
	            var context = this.context;
	            context.beginPath();
	            context.rect(this.x, this.y, this.width, this.height);
	            return this;
	        };
	        return Rect;
	    }());
	    exports.Rect = Rect;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(7)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, Antagonist_1) {
	    "use strict";
	    function getAntagonistArr(ctx, width, height) {
	        var antagonitsArr = [];
	        var p1Antagonist = new Antagonist_1.Antagonist(ctx);
	        p1Antagonist.x = 200;
	        p1Antagonist.y = 224;
	        p1Antagonist.lastMove = 'left';
	        p1Antagonist.canMove = true;
	        p1Antagonist.fillStyle = '#ff4a4a';
	        antagonitsArr.push(p1Antagonist);
	        var p2AntagonistA = new Antagonist_1.Antagonist(ctx);
	        p2AntagonistA.x = 608;
	        p2AntagonistA.y = 96;
	        p2AntagonistA.lastMove = 'right';
	        p2AntagonistA.canMove = true;
	        p2AntagonistA.fillStyle = '#ff4a4a';
	        antagonitsArr.push(p2AntagonistA);
	        var p2AntagonistB = new Antagonist_1.Antagonist(ctx);
	        p2AntagonistB.x = 808;
	        p2AntagonistB.y = 96;
	        p2AntagonistB.lastMove = 'left';
	        p2AntagonistB.canMove = true;
	        p2AntagonistB.fillStyle = '#e05353';
	        antagonitsArr.push(p2AntagonistB);
	        var p2AntagonistC = new Antagonist_1.Antagonist(ctx);
	        p2AntagonistC.x = 864;
	        p2AntagonistC.y = 224;
	        p2AntagonistC.lastMove = 'left';
	        p2AntagonistC.canMove = true;
	        p2AntagonistC.canShoot = true;
	        antagonitsArr.push(p2AntagonistC);
	        var p4AntagonistC = new Antagonist_1.Antagonist(ctx);
	        p4AntagonistC.x = 1536;
	        p4AntagonistC.y = 224;
	        p4AntagonistC.lastMove = 'left';
	        p4AntagonistC.canMove = true;
	        p4AntagonistC.canShoot = true;
	        p4AntagonistC.canJump = true;
	        p4AntagonistC.fillStyle = '#44c782';
	        antagonitsArr.push(p4AntagonistC);
	        return antagonitsArr;
	    }
	    exports.getAntagonistArr = getAntagonistArr;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, Character_1) {
	    "use strict";
	    var Antagonist = (function (_super) {
	        __extends(Antagonist, _super);
	        function Antagonist(context) {
	            var _this = _super.call(this, context) || this;
	            _this.context = context;
	            _this.canJump = false;
	            _this.canShoot = false;
	            _this.shootWait = 50;
	            _this.jumpWait = 10;
	            _this._canMove = false;
	            _this._shootWaitCount = 0;
	            _this._jumpWaitCount = 0;
	            // Super defaults override
	            _this.ySpeed = 6;
	            _this.xSpeed = 0.25;
	            _this.fillStyle = '#524f56';
	            _this.spriteFrames = {
	                defaultRight: [28, 0],
	                defaultLeft: [28, 16],
	                deathRight: [42, 0],
	                deathLeft: [42, 16]
	            };
	            // Defaults
	            _this.canJump = false;
	            _this.jumpWait = 25;
	            _this._jumpWaitCount = 0;
	            return _this;
	        }
	        Object.defineProperty(Antagonist.prototype, "canMove", {
	            get: function () {
	                return this._canMove;
	            },
	            set: function (val) {
	                this.move(this.lastMove);
	                this._canMove = true;
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Antagonist.prototype.update = function () {
	            if (!this.isDeath) {
	                // Auto jumping
	                if (this.canJump && !this._isJumping) {
	                    if (this._jumpWaitCount++ === this.jumpWait) {
	                        this.jump();
	                        this._jumpWaitCount = 0;
	                    }
	                }
	                // Auto shooting
	                if (this.canShoot) {
	                    if (this._shootWaitCount++ === this.shootWait) {
	                        this.shoot();
	                        this._shootWaitCount = 0;
	                    }
	                }
	            }
	            // Update super
	            _super.prototype.update.call(this);
	            return this;
	        };
	        Antagonist.prototype.collisionHandler = function (side, depth) {
	            _super.prototype.collisionHandler.call(this, side, depth);
	            // Keep moving after side collision
	            if (!this._isDeath) {
	                if (side === 'right')
	                    this.move('left');
	                if (side === 'left')
	                    this.move('right');
	            }
	            return this;
	        };
	        return Antagonist;
	    }(Character_1.Character));
	    exports.Antagonist = Antagonist;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(9), __webpack_require__(5), __webpack_require__(10), __webpack_require__(11), __webpack_require__(12)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, constants_1, Rect_1, Sprite_1, constants_2, Bullet_1) {
	    "use strict";
	    var Character = (function (_super) {
	        __extends(Character, _super);
	        function Character(context) {
	            var _this = _super.call(this, context) || this;
	            _this.context = context;
	            _this.friction = 0.75;
	            _this.xSpeed = 4;
	            _this.ySpeed = 8;
	            _this.clearWait = 25;
	            _this.lastMove = 'right';
	            _this.fillStyle = '#5575ff';
	            _this.spriteFrames = {
	                defaultRight: [0, 0],
	                defaultLeft: [0, 16],
	                deathRight: [14, 0],
	                deathLeft: [14, 16]
	            };
	            _this._xVel = 0;
	            _this._yVel = 0;
	            _this._isDeath = false;
	            _this._isJumping = false;
	            _this._isMovingLeft = false;
	            _this._isMovingRight = false;
	            _this._clearWaitCount = 0;
	            _this._bulletArr = [];
	            _this.width = 24;
	            _this.height = 32;
	            var spriteId = constants_1.IS_HIDPI ? 'js-sprite-2x' : 'js-sprite-1x';
	            _this.sprite = new Sprite_1.Sprite(context);
	            _this.sprite.img = document.getElementById(spriteId);
	            _this.sprite.width = 14;
	            _this.sprite.height = 16;
	            return _this;
	        }
	        Object.defineProperty(Character.prototype, "xVel", {
	            get: function () { return this._xVel; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(Character.prototype, "yVel", {
	            get: function () { return this._yVel; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(Character.prototype, "isDeath", {
	            get: function () { return this._isDeath; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(Character.prototype, "isJumping", {
	            get: function () { return this._isJumping; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(Character.prototype, "isMovingLeft", {
	            get: function () { return this._isMovingLeft; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(Character.prototype, "isMovingRight", {
	            get: function () { return this._isMovingRight; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(Character.prototype, "bulletArr", {
	            get: function () { return this._bulletArr; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(Character.prototype, "clearWaitCount", {
	            get: function () { return this._clearWaitCount; },
	            enumerable: true,
	            configurable: true
	        });
	        Character.prototype.kill = function () {
	            // Ends horizontal moving completly
	            this.stopMove();
	            this._xVel = 0;
	            // Ends vertical moving completly
	            this._isJumping = false;
	            this._yVel = 0;
	            this._isDeath = true;
	            return this;
	        };
	        Character.prototype.move = function (action) {
	            if (!this._isDeath) {
	                this._isMovingLeft = action === 'left';
	                this._isMovingRight = action === 'right';
	                this.lastMove = action;
	            }
	            return this;
	        };
	        Character.prototype.stopMove = function (action, sharp) {
	            if (sharp === void 0) { sharp = false; }
	            // End horizontal moving smoothly
	            this._isMovingRight = !action || action === 'right' ? false : this._isMovingRight;
	            this._isMovingLeft = !action || action === 'left' ? false : this._isMovingLeft;
	            return this;
	        };
	        Character.prototype.jump = function () {
	            // Abort if already jumping or not grounded (falling down from a cliff)
	            if (!this._isJumping && this._yVel === 0) {
	                this._isJumping = true;
	                this._yVel -= this.ySpeed;
	            }
	            return this;
	        };
	        Character.prototype.shoot = function () {
	            var _a = this, context = _a.context, x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	            var bullet = new Bullet_1.Bullet(context);
	            bullet.fillStyle = this.fillStyle;
	            bullet.x = (x + width / 2) - (bullet.width / 2);
	            bullet.y = (y + height / 2) - (bullet.height / 2);
	            bullet.move(this.lastMove);
	            this._bulletArr.push(bullet);
	            return this;
	        };
	        Character.prototype.update = function () {
	            if (!this._isDeath) {
	                // Move right
	                if (this._isMovingRight) {
	                    if (this._xVel < this.xSpeed) {
	                        this._xVel++;
	                    }
	                }
	                else if (this._isMovingLeft) {
	                    if (this._xVel > -this.xSpeed) {
	                        this._xVel--;
	                    }
	                }
	                else if (this._xVel !== 0) {
	                    if (Math.abs(this._xVel) < 0.05) {
	                        this._xVel = 0;
	                    }
	                    else {
	                        this._xVel *= this.friction;
	                    }
	                }
	                // Gravity must always push down
	                this._yVel += constants_2.GRAVITY;
	                // Make speed || friction affect x
	                this.x += this._xVel;
	                // Make gravity affect y
	                this.y += this._yVel;
	            }
	            return this;
	        };
	        Character.prototype.collisionHandler = function (side, depth) {
	            if (!this._isDeath) {
	                switch (side) {
	                    case 'left':
	                        this.x += depth;
	                        break;
	                    case 'right':
	                        this.x -= depth;
	                        break;
	                    case 'top':
	                        this.y += depth;
	                        // Update vertical movement
	                        this._yVel = 0;
	                        break;
	                    case 'bottom':
	                        this.y -= depth;
	                        break;
	                }
	                // Stop character horizontal movement
	                if (side === 'left' || side === 'right') {
	                    this._xVel = 0;
	                }
	                // Stop vertical movement if character is moving down
	                if (side === 'bottom' && this._yVel > 0) {
	                    this._yVel = 0;
	                    if (this._isJumping) {
	                        this._isJumping = false;
	                    }
	                }
	            }
	            return this;
	        };
	        Character.prototype.render = function () {
	            var context = this.context;
	            if (this._isDeath) {
	                if (this._clearWaitCount === this.clearWait) {
	                    // Avoid rendering
	                    return this;
	                }
	                this._clearWaitCount++;
	            }
	            context.fillStyle = this.fillStyle;
	            _super.prototype.render.call(this);
	            context.fill();
	            this.renderFace();
	            return this;
	        };
	        Character.prototype.renderFace = function () {
	            var _a = this, sprite = _a.sprite, lastMove = _a.lastMove, spriteFrames = _a.spriteFrames;
	            sprite.yPosition = this.y;
	            sprite.xPosition = this.x;
	            if (lastMove === 'right') {
	                sprite.xPosition += this.width - sprite.width;
	            }
	            if (this.isDeath) {
	                if (lastMove === 'right') {
	                    sprite.xOrigin = spriteFrames.deathRight[0];
	                    sprite.yOrigin = spriteFrames.deathRight[1];
	                }
	                else {
	                    sprite.xOrigin = spriteFrames.deathLeft[0];
	                    sprite.yOrigin = spriteFrames.deathLeft[1];
	                }
	            }
	            else {
	                if (lastMove === 'right') {
	                    sprite.xOrigin = spriteFrames.defaultRight[0];
	                    sprite.yOrigin = spriteFrames.defaultRight[1];
	                }
	                else {
	                    sprite.xOrigin = spriteFrames.defaultLeft[0];
	                    sprite.yOrigin = spriteFrames.defaultLeft[1];
	                }
	            }
	            sprite.render();
	            return this;
	        };
	        return Character;
	    }(Rect_1.Rect));
	    exports.Character = Character;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    "use strict";
	    /**
	     * Is high resolution device
	     * @const
	     */
	    exports.IS_HIDPI = window.devicePixelRatio > 1;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, constants_1) {
	    "use strict";
	    var Sprite = (function () {
	        /**
	         * Interface that renders and updates a single sprite
	         */
	        function Sprite(context) {
	            this.context = context;
	            this.xOrigin = 0;
	            this.yOrigin = 0;
	            this.xPosition = 0;
	            this.yPosition = 0;
	            this.width = 0;
	            this.height = 0;
	        }
	        /**
	         * Renders the sprite in the given context
	         */
	        Sprite.prototype.render = function () {
	            var _a = this, xOrigin = _a.xOrigin, yOrigin = _a.yOrigin, xPosition = _a.xPosition, yPosition = _a.yPosition, width = _a.width, height = _a.height;
	            var sX = constants_1.IS_HIDPI ? xOrigin * 2 : xOrigin;
	            var sY = constants_1.IS_HIDPI ? yOrigin * 2 : yOrigin;
	            var sWidth = constants_1.IS_HIDPI ? width * 2 : width;
	            var sHeight = constants_1.IS_HIDPI ? height * 2 : height;
	            this.context.drawImage(this.img, sX, sY, sWidth, sHeight, xPosition, yPosition, width, height);
	            return this;
	        };
	        return Sprite;
	    }());
	    exports.Sprite = Sprite;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    "use strict";
	    /**
	     * Game gravity
	     */
	    exports.GRAVITY = 0.4;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, Rect_1) {
	    "use strict";
	    var Bullet = (function (_super) {
	        __extends(Bullet, _super);
	        function Bullet(context) {
	            var _this = _super.call(this, context) || this;
	            _this.context = context;
	            _this.xSpeed = 12;
	            _this.remove = false;
	            _this.fillStyle = 'white';
	            _this._isMovingLeft = false;
	            _this._isMovingRight = false;
	            _this._firstUpdate = true;
	            _this.width = 8;
	            _this.height = 8;
	            return _this;
	        }
	        Object.defineProperty(Bullet.prototype, "isMovingLeft", {
	            get: function () { return this._isMovingLeft; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(Bullet.prototype, "isMovingRight", {
	            get: function () { return this._isMovingRight; },
	            enumerable: true,
	            configurable: true
	        });
	        Bullet.prototype.move = function (action) {
	            this._isMovingLeft = action === 'left';
	            this._isMovingRight = action === 'right';
	            return this;
	        };
	        Bullet.prototype.stopMove = function (action, sharp) {
	            if (sharp === void 0) { sharp = false; }
	            this._isMovingRight = !action || action === 'right' ? false : this._isMovingRight;
	            this._isMovingLeft = !action || action === 'left' ? false : this._isMovingLeft;
	            return this;
	        };
	        Bullet.prototype.update = function () {
	            if (this._firstUpdate) {
	                this._firstUpdate = false;
	            }
	            else {
	                this.x += this._isMovingRight ? this.xSpeed : -this.xSpeed;
	            }
	            return this;
	        };
	        Bullet.prototype.collisionHandler = function (side, depth) {
	            if (side === 'left') {
	                this.x += depth;
	            }
	            if (side === 'right') {
	                this.x -= depth;
	            }
	            this.remove = true;
	            return this;
	        };
	        Bullet.prototype.render = function () {
	            var context = this.context;
	            context.fillStyle = this.fillStyle;
	            _super.prototype.render.call(this);
	            context.fill();
	            return this;
	        };
	        return Bullet;
	    }(Rect_1.Rect));
	    exports.Bullet = Bullet;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    "use strict";
	    var Stage = (function () {
	        function Stage(context) {
	            this.context = context;
	            this.y = 0;
	            this.outerWidth = 0;
	            this.outerHeight = 0;
	            this.innerWidth = 0;
	            this.innerHeight = 0;
	            this.xTranslateStart = 0;
	            this.xTranslateEnd = 0;
	            this._x = 0;
	        }
	        Object.defineProperty(Stage.prototype, "x", {
	            get: function () {
	                return this._x;
	            },
	            set: function (val) {
	                var _a = this, xTranslateStart = _a.xTranslateStart, xTranslateEnd = _a.xTranslateEnd, outerWidth = _a.outerWidth, innerWidth = _a.innerWidth;
	                if (val > xTranslateStart) {
	                    if (val > xTranslateEnd) {
	                        this._x = outerWidth - innerWidth;
	                    }
	                    else {
	                        this._x = xTranslateStart - val;
	                    }
	                }
	                else {
	                    this._x = 0;
	                }
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Stage.prototype.render = function () {
	            var context = this.context;
	            context.setTransform(1, 0, 0, 1, 0, 0);
	            context.translate(this.x, 0);
	            return this;
	        };
	        return Stage;
	    }());
	    exports.Stage = Stage;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }
/******/ ]);


// WEBPACK FOOTER //
// app.js